import React from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import T from 'i18n-react';
import { makeStyles } from '@material-ui/core/styles';
import { makeSubtitleStyles } from '../../core/Plans/styles';
import { API_BUSINESS_REVIEWS } from '../routing';
import BaseReviewContainer from '../../core/Reviews/ReviewContainer';
import { ContainerProps as MuiContainerProps } from '@material-ui/core/Container';
import type { ReviewProps } from '../../core/Reviews/Review';
import type { AtmosphereReviewProps } from './AtmosphereReview';
import {
  getImageSrc,
  getName,
  getParticipantJoinTime,
} from '../../core/Reviews/user';
import AtmosphereReview from './AtmosphereReview';

const useStyles = makeStyles((theme) => ({
  title: {
    ...makeSubtitleStyles(theme),
    paddingBottom: theme.spacing(0.5),
  },
}));

type ReviewContainerProps = {
  businessId: number,
  next?: boolean,
  ContainerProps?: MuiContainerProps,
  reviews?: Array<ReviewProps>,
  atmosphereReviews?: AtmosphereReviewProps,
  titleProps?: TypographyProps,
  count?: number,
  averageRating?: number,
};

const ReviewContainer = ({
  reviews = [],
  businessId,
  next = false,
  count,
  averageRating,
  ContainerProps = {},
  titleProps = {},
  atmosphereReviews = {},
}: ReviewContainerProps) => {
  const classes = useStyles();

  return (
    <BaseReviewContainer
      ContainerProps={ContainerProps}
      atmosphereReviews={
        atmosphereReviews.options != null &&
        count > 0 && (
          <AtmosphereReview
            options={atmosphereReviews.options}
            color={atmosphereReviews.color}
            rating={atmosphereReviews.rating}
          />
        )
      }
      title={
        <Typography className={classes.title} {...titleProps}>
          {T.translate('reviewContainer.title')}
        </Typography>
      }
      apiPath={API_BUSINESS_REVIEWS.replace(':businessId', businessId)}
      next={next}
      limit={50}
      apiResponseConverter={({
        message,
        rating,
        maxRating,
        sex,
        age,
        online,
        startsAt,
      }) => ({
        message,
        rating,
        maxRating,
        sex,
        age,
        online,
        name: getName(sex, age),
        imageSrc: getImageSrc(sex),
        joinTime: getParticipantJoinTime(startsAt),
      })}
      reviews={reviews.map(({ sex, age, startsAt, ...other }) => ({
        ...other,
        imageSrc: getImageSrc(sex),
        name: getName(sex, age),
        joinTime: getParticipantJoinTime(startsAt),
      }))}
      reviewsCount={count}
      totalRating={averageRating}
      scroller={true}
    />
  );
};

export default ReviewContainer;
